export default "__VITE_ASSET__BAE1aUx$__"